import React from 'react';

interface PageContainerProps {
    children: React.ReactNode;
    maxWidth?: string;
    className?: string;
    style?: React.CSSProperties;
}

export const PageContainer: React.FC<PageContainerProps> = ({
    children,
    maxWidth = '1600px',
    className = '',
    style
}) => {
    return (
        <div 
            className={`min-h-screen py-4 md:py-6 px-4 md:px-6 fade-in ${className}`}
            style={style}
        >
            <div className="mx-auto w-full space-y-6" style={{ maxWidth }}>
                {children}
            </div>
        </div>
    );
};

export default PageContainer;

